import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getConciergeToken } from "../../../../utils/conciergeCmsAuth";
import { useConciergeUserAuth } from "./ConciergeUserAuthContext";

export default function ConciergeUserProtectedRoute() {
  const location = useLocation();
  const { ready, me } = useConciergeUserAuth();

  if (!ready) return null;

  const token = getConciergeToken();
  if (!token || !me) {
    return <Navigate to="/concierge/manage/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}

